var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiagram = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15 3.6H5.34C5.83706 3.6 6.24 3.92236 6.24 4.32V6.51471C6.24 6.9007 5.86034 7.21573 5.38351 7.23388L9.582 7.23388C10.0791 7.23388 10.482 7.55624 10.482 7.95388V10.1488C10.482 10.5465 10.0791 10.8688 9.582 10.8688L14.85 10.8688C15.3471 10.8688 15.75 11.1912 15.75 11.5888V13.68C15.75 14.0776 15.3471 14.4 14.85 14.4L3.15 14.4C2.65294 14.4 2.25 14.0776 2.25 13.68L2.25 10.8688L2.25 7.23388L2.25 4.32C2.25 3.92236 2.65294 3.6 3.15 3.6Z",
    fill: "#FBBB00",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 7.23388H5.38351M2.25 7.23388L5.3397 7.23471C5.35439 7.23471 5.36899 7.23444 5.38351 7.23388M2.25 7.23388L2.25 4.32C2.25 3.92236 2.65294 3.6 3.15 3.6H5.34C5.83706 3.6 6.24 3.92236 6.24 4.32V6.51471C6.24 6.9007 5.86034 7.21573 5.38351 7.23388M2.25 7.23388L2.25 10.8688M5.38351 7.23388L9.582 7.23388C10.0791 7.23388 10.482 7.55624 10.482 7.95388V10.1488C10.482 10.5465 10.0791 10.8688 9.582 10.8688M2.25 10.8688H9.582M2.25 10.8688L2.25 13.68C2.25 14.0776 2.65294 14.4 3.15 14.4L14.85 14.4C15.3471 14.4 15.75 14.0776 15.75 13.68V11.5888C15.75 11.1912 15.3471 10.8688 14.85 10.8688L9.582 10.8688M2.25 16.2V1.8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiagram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/diagram.3e4aa1697a6bb0a2b1fc6a4e111e7d1a.svg";